import { crudMdActions } from "@/services/crud-md-actions";

const name = "trainings";

export default {
  name,
  ...crudMdActions(name, "trainings"),
};
